module.exports = __webpack_public_path__ + "img/2.08b79364.jpg";